import clsx from 'clsx'
import React, { useContext, useMemo, useRef } from 'react'

import { Breadcrumbs as BreadcrumbsV3 } from '@Components/Breadcrumbs'
import { ProductContext } from '@Components/Product/Context'
import SliderProvider from '@Components/Product/Slider'
import { Breadcrumbs as BreadcrumbsV2 } from '@Domains/Product/Features/Display/Breadcrumbs/Breadcrumbs'
import { getGalleryAssets } from '@Domains/Product/Features/Display/GalleryAssets'
import { Info } from '@Domains/Product/Features/Display/Info/Info'
import ProductSliders from '@Domains/Product/Features/Display/ProductSliders/ProductSliders'
import ProductTactics from '@Domains/Product/Features/Tactics/ProductTactics'
import { PagePresentation } from '@Generated/graphql'
import { AnchorItemInjections } from '@Globals/Injections/Client'
import { MetadataContext } from '@Globals/Metadata'
import { useSplitTest } from '@Globals/SplitTests/Hooks'

import styles from './Display.module.scss'

export const ProductDisplay = ({
  id,
  presentation = PagePresentation.Full,
}: {
  id?: string
  presentation?: PagePresentation
}) => {
  const product = useContext(ProductContext)
  const assets = useMemo(() => getGalleryAssets(product), [product])
  const scrollToRef = useRef<HTMLDivElement>(null)
  const { page: { breadcrumbs = [] } = {} } = useContext(MetadataContext)
  const breadcrumbsV3 = useSplitTest('breadcrumbs_v3', 'b')

  if (!product) {
    return null
  }

  // TODO: render according to spec
  if (presentation === PagePresentation.Sidebar) {
    return (
      <div className={styles.spacing} id={id}>
        <Info reviewWrapperRef={scrollToRef} />
      </div>
    )
  }

  return (
    <div className={clsx(styles.wrapper, styles.spacing)} id={id}>
      <div className={styles.content}>
        <div className={styles.layout}>
          <div className={styles.slider}>
            <div className={styles.sticky}>
              {!breadcrumbsV3 && <BreadcrumbsV2 breadcrumbs={breadcrumbs} />}
              {breadcrumbsV3 && <BreadcrumbsV3 breadcrumbs={breadcrumbs} className={styles.productBreadcrumbs} maxElements={2} />}
              <SliderProvider slides={assets}>
                <ProductSliders />
              </SliderProvider>
            </div>
          </div>
          <Info reviewWrapperRef={scrollToRef} />
        </div>

        <AnchorItemInjections anchor="tactics.silver.before" />
        <ProductTactics group="silver" />
        <AnchorItemInjections anchor="tactics.silver.after" />
      </div>
    </div>
  )
}
